// extracted by mini-css-extract-plugin
export default {"containerHeading":"styles_containerHeading__++AbJ"};